// extracted by mini-css-extract-plugin
module.exports = {"tab":"TabButton_tab__1zAfA","tabActive":"TabButton_tabActive__2diPX"};